import AnnuairePage from "@/pages/annuaire/AnnuairePage.vue";
import AnnuaireFileForm from "@/pages/annuaire/AnnuaireFileForm.vue";
import AnnuaireLinePage from "@/pages/annuaire/AnnuairePage.vue";
// import AnnuaireLineDetails from "@/pages/annuaire/AnnuaireLineDetails.vue";
import AnnuaireFileDetails from "@/pages/annuaire/AnnuaireFileDetails.vue";

export default [
  {
    path: '/annuaire/:id',
    component: AnnuairePage,
    props: false
  },
  {
    path: '/annuaire/line/:id',
    component: AnnuaireLinePage,
    props: true
  },
  {
    path: '/annuaireform/create',
    component: AnnuaireFileForm,
    props: true
  },
  {
    path: '/annuaire/file/:id',
    component: AnnuaireFileDetails,
    props: true
  }
]
